import React from 'react';
import { ProductInterface } from 'modules/product/interfaces/product.interface';
import Icon from 'atomic/icon';

import './product-attributes-table.scss';

interface ProductAttributesProps {
    slice?: number;
    attributes: ProductInterface['attributes'];
    showRichContentLink?: boolean;
}

const ProductAttributesTable: React.FC<ProductAttributesProps> = ({ attributes, showRichContentLink = false }) => (
    <div className="product-attributes">
        <div className="product-attributes__header">
            <h3 className="title">Dane techniczne</h3>
            { showRichContentLink && (
                <a className="link" href="#slownik-pojec">
                    <Icon name="book-open" color="primary" size={16} />
                    Słownik pojęć
                </a>
            )}
        </div>

        <table className="attributes-details">
            <tbody>
                {
                    attributes.map(item => (
                        <tr className="attributes-details__item" key={item.label}>
                            <td className="attributes-details__item-label">
                                {item.label}
                            </td>
                            <td className="attributes-details__item-value">
                                {item.value}
                            </td>
                        </tr>
                    ))
                }
            </tbody>
        </table>
    </div>
);

export default ProductAttributesTable;
